var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextInputWithSelect',_vm._g(_vm._b({staticClass:"hour-picker",attrs:{"items":_vm.selectItems,"menuProps":{
  top: _vm.isMobile,
},"should-open-menu":_vm.openMenu},on:{"select-input":_vm.handleSelectInput,"input":_vm.handleInput}},'TextInputWithSelect',_vm.$attrs,false),_vm.$listeners),[(_vm.isMobile)?_c('input',{ref:"nativeInputElement",staticClass:"native-time-input",attrs:{"type":"time"},on:{"input":_vm.handleNativeInput}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }